<template>
  <div>
    <el-dialog :visible.sync="visible" custom-class="theme-dialog" width="680px" @close="handleCancel">
      <div slot="title" class="popup-head">
        <span class="popup-tit">更换皮肤</span>
      </div>
      <div v-loading="loading">
        <div class="popup-body">
          <div class="content">
            <div class="popup-skin-tab">
              <ul class="tabs-head group-tabs">
                <li class="tabs-item" @click="clickTheme(item)" v-for="(item, index) in themeList">
                  <a href="javascript:;" :class="['tabs-link', item.name === activeName && 'active']">{{ item.title }}</a>
                </li>
              </ul>
              <div class="tabs-body">
                <div class="tabs-con">
                  <div class="skin-img"><img :src="checkTheme.imagePath"  alt=""></div>
                  <div :class="['skin-bg', activeName]"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="popup-foot group">
        <a href="javascript:" class="btn btn btn-anti-default" @click="handleCancel">取消</a>
        <a href="javascript:" class="btn btn btn-solid-primary" @click="setTheme">确定</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'theme-switch',
    data() {
      return {
        cssVersion: '20220425',
        activeName: '',
        themePath: '',
        visible: false,
        loading: false,
        checkTheme: {},
        themeList: [
          {
            title: '高校风',
            name: 'main-blue',
            path: 'static/styles/css/main.css',
            imagePath: 'static/styles/images/skin-blue.jpg'
          },
          {
            title: '党建风',
            name: 'main-polity',
            path: 'static/styles/css/main-cyan.css',
            imagePath: 'static/styles/images/skin-polity.jpg'
          },
          {
            title: '中国风',
            name: 'main-china',
            path: 'static/styles/css/main-china.css',
            imagePath: 'static/styles/images/skin-china.jpg'
          }
        ]
      }
    },
    created() {
      this.activeName = util.initUserTheme()
      for (let i = 0; i < this.themeList.length; i++) {
        if (this.activeName === this.themeList[i].name) {
          this.checkTheme = this.themeList[i]
          break
        }
      }
    },
    methods: {
      show () {
        this.visible = true
      },
      hide () {
        this.visible = false
      },
      setTheme() { // 提交设置皮肤
        localStorage.setItem('theme', this.activeName)
        util.changeTheme()
        this.$emit('theme-change-success')
      },
      handleCancel () {
        this.hide()
      },
      clickTheme(item) {
        this.checkTheme = item
        this.activeName = this.checkTheme.name
        this.themePath = this.checkTheme.path
      }
    }
  }
</script>
<style lang="scss">
.theme-dialog {
  z-index: 1;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }

  .el-dialog__headerbtn {
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border: 1px solid transparent;
    line-height: 22px;
    border-radius: 4px;
    font-size: 18px;

    &:hover {
      color: inherit;
      background-color: #f3f5f7;
    }

    .el-dialog__close {
      color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/theme-switch/theme-switch.vue